import React, { useState } from "react";
import { useEvent } from "@hooks/useEvent";
import { Text } from "@fragments";
import { VideoCallRounded } from "@mui/icons-material";
import ImageImportTool from "@components/ImageImportTool";
import VideoUpload from "../components/VideoUpload";
import VideosUploadStatusBox from "../components/VideosUploadStatusBox";
import EVENTS from "../events";

export default function Video({
    defaultAspectRatio,
    defaultBanner,
    defaultVideoUrl,
    onBannerLoaded,
    onVideoUploaded,
    onRemoveVideo,
    onGenerateThumb
}) {
    const [aspectRatio, setAspectRatio] = useState(defaultAspectRatio || 1.78);
    const [videoUrl, setVideoUrl] = useState(defaultVideoUrl);
    const [banner, setBanner] = useState(defaultBanner);

    useEvent(EVENTS.ASPECT_RATIO_CHANGE, (ratio) => {
        setAspectRatio(ratio);
    });

    useEvent(EVENTS.VIDEO_URL_CHANGE, (url) => {
        setVideoUrl(url);
    });

    useEvent(EVENTS.BANNER_CHANGE, (b) => {
        setBanner(b);
    });

    return (
        <>
            <Text.h3
                left={<VideoCallRounded />}
                value="Vídeo"
                className="mb-1 mt-4"
            />

            <div className="video-upload-area " style={{
                width: aspectRatio > 1 ? '100%' : 'fit-content'
            }}>
                <div className="banner-select-box">
                    <ImageImportTool
                        size={aspectRatio > 1 ? 100 : 140}
                        aspectRatio={aspectRatio}
                        onCrop={onBannerLoaded}
                        src={banner}
                        title="Banner"
                        displayTitle
                    />
                </div>
                <VideoUpload
                    aspectRatio={aspectRatio}
                    handleRemoveVideo={onRemoveVideo}
                    url={videoUrl}
                    onSelected={onGenerateThumb}
                    onLoaded={onVideoUploaded}
                />
                <VideosUploadStatusBox />
            </div>
        </>
    );
}
